module.exports = __webpack_public_path__ + "static/img/team6.b60f624.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/instructors/team6.jpg
// module id = MxAC
// module chunks = 1